module.exports = __webpack_public_path__ + "img/checkmark-double-green.2728e97.svg";